export default __webpack_public_path__ + "static/media/ig.e1279cce.svg";